// Auto-generated translation for it.
// Source: landings.js, translated via Claude Sonnet on 2026-05-26T11:07:34.959183+00:00.

export const LANDINGS = {
  "eigen-paard": {
    slug: "eigen-paard",
    eyebrow: "Per i proprietari di cavalli",
    title: "Tutto per il tuo cavallo. In un'unica app.",
    subtitle: "Gestisci salute, allenamento, pianificazione e professionisti da un unico dossier chiaro e completo.",
    primaryCTA: {
      label: "Inizia gratis",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Scopri Premium",
      href: "/premium",
    },
    heroScreenshot: {
      url: "/assets/owner-horse.png",
      alt: "Profilo cavallo — peso, vaccinazioni, EquiCoach, alimentazione e allenamento in un'unica schermata",
      caption: "Il tuo cavallo, sempre sotto controllo.",
    },
    problem: "Probabilmente tieni appuntamenti, foto, allenamento, alimentazione e salute sparsi ovunque — in gruppi WhatsApp, scatole di scarpe e app separate. Così perdi il filo.",
    solution: "EquiSight trasforma il tuo cavallo in un unico dossier digitale completo, sempre con te.",
    benefits: [
      "Un profilo completo per ogni cavallo",
      "Salute, maniscalco, dentista e fisioterapista in un unico posto",
      "Agenda con promemoria intelligenti",
      "Foto, note e storico senza limiti",
      "Backup di tutti i tuoi dati con Premium",
    ],
    pricing: {
      tiers: [
        {
          name: "Basic",
          price: "€0",
          note: "1 cavallo · sempre gratis",
        },
        {
          name: "Premium",
          price: "€4,99",
          note: "Più cavalli + backup",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Pronto per iniziare?",
      title: "Aggiungi oggi il tuo primo cavallo.",
      href: "/#waitlist",
    },
  },
  "premium": {
    slug: "premium",
    eyebrow: "Premium",
    title: "Più cavalli. Più controllo. Più certezza.",
    subtitle: "Passa a Premium e gestisci tutti i tuoi cavalli senza limiti — con la piena intelligenza di EquiCoach.",
    primaryCTA: {
      label: "Inizia 14 giorni gratis",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Tutti i prezzi",
      href: "/#pricing",
    },
    audience: "Per proprietari, cavalieri sportivi e gestori di scuderia con più cavalli.",
    features: [
      "Aggiungi cavalli illimitati",
      "Cronologia completa per ogni cavallo",
      "Backup dei dati",
      "Approfondimenti avanzati di EquiCoach",
      "Notifiche intelligenti e pianificazione",
      "Salute e allenamento completamente integrati",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Meno di €0,17 al giorno",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Pronto?",
      title: "Passa a Premium.",
      href: "/#waitlist",
    },
  },
  "manege-ruiter": {
    slug: "manege-ruiter",
    eyebrow: "Per i cavalieri da maneggio",
    title: "Migliorarsi, anche senza un cavallo proprio.",
    subtitle: "Segui le tue lezioni, gli allenamenti e il tuo sviluppo all'interno di EquiSight — per meno del costo di un caffè al mese per mamma o papà. O un bel gelato con panna montata.",
    primaryCTA: {
      label: "Inizia con Premium",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Come funziona?",
      href: "#features",
    },
    problem: "Come cavaliere da maneggio spesso non hai un cavallo tutto tuo, ma vuoi comunque crescere e tenere traccia delle tue lezioni, dei tuoi obiettivi e dei cavalli su cui monti.",
    solution: "Le funzionalità per il maneggio sono incluse di default in Premium — segui il tuo sviluppo personale e visualizza i cavalli del maneggio collegati in modalità sola lettura.",
    features: [
      "Registrare gli allenamenti",
      "Fissare obiettivi",
      "Seguire i progressi",
      "Visualizzare i cavalli del maneggio con nome e foto",
      "Nessun accesso ai dati sanitari privati",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Al mese · funzionalità maneggio incluse",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Diventa membro",
      title: "Inizia come cavaliere da maneggio.",
      href: "/#waitlist",
    },
  },
  "manege-module": {
    slug: "manege-module",
    eyebrow: "Per maneggi e scuderie",
    title: "Rendi il tuo maneggio digitalmente accessibile a ogni cavaliere.",
    subtitle: "Offri ai cavalieri un legame con i cavalli, le lezioni e i progressi — senza condividere dati sensibili della scuderia.",
    primaryCTA: {
      label: "Richiedi accesso",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Scopri i moduli",
      href: "#features",
    },
    audience: "EquiSight aiuta maneggi e scuderie a mantenere i cavalieri più coinvolti e a distinguersi digitalmente.",
    features: [
      "Rendere visibili i cavalli del maneggio ai cavalieri",
      "Nome e foto per ogni cavallo",
      "Associare i cavalieri ai cavalli",
      "Accesso in sola lettura per i dati sensibili sulla privacy",
      "Storico delle lezioni e degli allenamenti centralizzato",
      "Gestione utenti con ruoli",
    ],
    benefits: [
      "Maggiore coinvolgimento dei cavalieri",
      "Immagine più professionale",
      "Servizio digitale aggiuntivo per i membri",
      "Nuova fonte di guadagno tramite l'utilizzo dell'app",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Al mese · funzionalità maneggio inclusa per i cavalieri",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Pronti?",
      title: "Attiva il Modulo Maneggio.",
      href: "/#waitlist",
    },
  },
  "fokkerij": {
    slug: "fokkerij",
    eyebrow: "Modulo allevamento",
    title: "Controllo completo su ciclo, gravidanza e sviluppo del puledro.",
    subtitle: "Il modulo di allevamento completo per proprietari di fattrici e allevatori — dalla monta al puledro, in un'unica cronologia.",
    primaryCTA: {
      label: "Attiva il Modulo Allevamento",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Scopri le funzionalità",
      href: "#features",
    },
    audience: "Per allevatori, proprietari di fattrici e scuderie che gestiscono più fattrici.",
    features: [
      "Monitoraggio del ciclo",
      "Registrazione del calore",
      "Registrazione delle date di inseminazione",
      "Conto alla rovescia per le ecografie",
      "Pianificazione dei controlli di gravidanza",
      "Albero genealogico e pedigree",
      "Sviluppo del puledro",
      "Panoramica di tutte le fattrici in gravidanza",
    ],
    pricing: {
      tiers: [
        {
          name: "Pro",
          price: "€14,99",
          note: "Al mese · Modulo allevamento incluso nel Pro",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Inizia oggi",
      title: "Inizia a gestire il tuo allevamento.",
      href: "/#waitlist",
    },
  },
  "hoefsmid": {
    slug: "hoefsmid",
    eyebrow: "Modulo maniscalco",
    title: "Lavora in modo più intelligente come maniscalco. Registra tutto in modo professionale.",
    subtitle: "Agenda, foto, note e storico dei trattamenti in un unico modulo — meno incomprensioni, documentazione più solida.",
    primaryCTA: {
      label: "Inizia come maniscalco",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Scopri il Pacchetto Professional",
      href: "/professional",
    },
    audience: "Per i maniscalchi che vogliono migliorare la gestione, la documentazione e la comunicazione con i clienti.",
    features: [
      "Agenda personale",
      "Appuntamenti per cliente",
      "Visualizzazione profili dei cavalli",
      "Aggiunta di foto prima e dopo",
      "Annotazione del trattamento",
      "Registrazione di consigli e osservazioni",
      "Notifica ETA al cliente: \"Il maniscalco è in arrivo\"",
    ],
    benefits: [
      "Lavoro più professionale",
      "Meno incomprensioni",
      "Documentazione più accurata",
      "Maggiore tutela in caso di responsabilità",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Al mese · Modulo maniscalco incluso nel Professional",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Pronto?",
      title: "Attiva il Modulo Maniscalco.",
      href: "/#waitlist",
    },
  },
  "paardentandarts": {
    slug: "paardentandarts",
    eyebrow: "Modulo dentista",
    title: "Un dossier dentale completo per ogni cavallo.",
    subtitle: "Registra rilievi, trattamenti e follow-up direttamente in EquiSight.",
    primaryCTA: {
      label: "Inizia come dentista equino",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Scopri il Pacchetto Professional",
      href: "/professional",
    },
    audience: "Dentisti equini, veterinari e studi che vogliono lavorare in modo strutturato.",
    features: [
      "Registrare il controllo dentale",
      "Rilievi per trattamento",
      "Aggiungere foto",
      "Reportistica al proprietario",
      "Consiglio di follow-up",
      "Storico per cavallo",
      "Pianificare un nuovo appuntamento",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Al mese · Modulo dentista incluso nel Professional",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Pronto?",
      title: "Attiva il Modulo Dentista.",
      href: "/#waitlist",
    },
  },
  "fysio-osteo": {
    slug: "fysio-osteo",
    eyebrow: "Modulo Fisio / Osteo",
    title: "Monitora corpo, movimento e recupero in modo professionale.",
    subtitle: "Per fisioterapisti e osteopati che vogliono seguire i cavalli in modo strutturato.",
    primaryCTA: {
      label: "Inizia come fisio/osteo",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Scopri il Pacchetto Professional",
      href: "/professional",
    },
    features: [
      "Anamnesi per cavallo",
      "Registrare i rilievi corporei",
      "Aggiungere foto e video",
      "Creare report di trattamento",
      "Condividere esercizi e follow-up",
      "Monitorare il percorso di recupero",
      "Storico per cavallo",
    ],
    benefits: [
      "Visione più approfondita nel tempo",
      "Reportistica professionale",
      "Comunicazione chiara con proprietario, addestratore e cavaliere",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Al mese · Modulo Fisio / Osteo incluso in Professional",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Pronto?",
      title: "Attiva il Modulo Fisio / Osteo.",
      href: "/#waitlist",
    },
  },
  "trainer": {
    slug: "trainer",
    eyebrow: "Modulo Trainer",
    title: "Allena i cavalieri con dati, obiettivi e progressi.",
    subtitle: "Rendi l'allenamento misurabile e la guida più professionale — per uno o più cavalieri.",
    primaryCTA: {
      label: "Inizia come trainer",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Scopri il pacchetto Pro",
      href: "/#pricing",
    },
    audience: "Per istruttori, trainer e coach con più cavalieri o cavalli.",
    features: [
      "Collegare i cavalieri",
      "Seguire i cavalli",
      "Impostare obiettivi di allenamento",
      "Fornire feedback",
      "Analizzare i risultati di gara",
      "Visualizzare i progressi per combinazione",
      "Utilizzare analisi dei protocolli per il focus dell'allenamento",
    ],
    benefits: [
      "Guida migliore",
      "Maggiore struttura",
      "Comunicazione più professionale",
      "Maggiore fidelizzazione dei clienti",
    ],
    pricing: {
      tiers: [
        {
          name: "Pro",
          price: "€14,99",
          note: "Al mese · Modulo Trainer incluso nel Pro",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Pronto?",
      title: "Attiva il Modulo Trainer.",
      href: "/#waitlist",
    },
  },
  "wedstrijdanalyse": {
    slug: "wedstrijdanalyse",
    eyebrow: "Analisi delle gare",
    title: "Dal protocollo al miglioramento delle prestazioni.",
    subtitle: "Carica il tuo protocollo di gara e scopri dove stai perdendo punti — non solo visualizzare il tuo punteggio, ma capire come migliorare.",
    primaryCTA: {
      label: "Analizza il tuo primo protocollo",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Scopri Premium",
      href: "/premium",
    },
    features: [
      "Caricamento foto del protocollo",
      "Elaborazione fronte e retro",
      "Riconoscimento di classe, numero di prova e giudice",
      "Analisi dei punteggi per esercizio",
      "Riepilogo dei commenti",
      "Visualizzazione dei punti di forza e di debolezza",
      "Tendenze per combinazione cavallo-cavaliere",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Al mese · analisi delle gare inclusa a partire da Premium",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Pronto?",
      title: "Inizia con l'analisi delle gare.",
      href: "/#waitlist",
    },
  },
  "professional": {
    slug: "professional",
    eyebrow: "Bundle Professional",
    title: "Per i professionisti del mondo equestre.",
    subtitle: "Maniscalco, dentista, fisioterapista, osteopata o istruttore: collaborate in un unico fascicolo digitale del cavallo.",
    primaryCTA: {
      label: "Inizia come professionista",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Scopri i moduli separati",
      href: "#features",
    },
    audience: "Il Bundle Professional combina tutti i moduli specialistici in un unico abbonamento.",
    features: [
      "Modulo Maniscalco",
      "Modulo Dentista",
      "Modulo Fisio / Osteo",
      "Agenda e gestione clienti",
      "Profili dei cavalli e report",
      "Storico dei trattamenti e archivio dossier",
      "Comunicazione con il proprietario",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Al mese · tutti i moduli specialistici inclusi",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Pronti?",
      title: "Scegli Professional.",
      href: "/#waitlist",
    },
  },
  "noodnummerpaard": {
    slug: "noodnummerpaard",
    eyebrow: "Numeri di emergenza per il cavallo",
    title: "Il giusto aiuto sempre a portata di mano.",
    subtitle: "In un'emergenza ogni secondo conta. Con EquiSight hai tutti i contatti importanti del tuo cavallo sempre pronti — un tocco e chiami.",
    primaryCTA: {
      label: "Prepara i tuoi contatti di emergenza",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Inizia gratuitamente con EquiSight",
      href: "/#waitlist",
    },
    accent: "danger",
    heroScreenshot: {
      url: "/assets/emergency.png",
      alt: "Contatti di emergenza — chiama, manda un WhatsApp o naviga direttamente verso il veterinario, la clinica e il maniscalco",
      caption: "Un tocco. Niente panico.",
      embeddedFrame: true,
    },
    problem: "Il tuo cavallo ha qualcosa — coliche, infortunio, panico. E inizia la ricerca. Chi chiami? Hai il numero giusto? È il numero di emergenza? Si perde tempo prezioso.",
    solution: "Con EquiSight hai tutto a portata di mano. Niente ricerche. Nessun dubbio. Un tocco e sei in contatto.",
    scenario: {
      title: "Immagina — il tuo cavallo mostra sintomi di colica.",
      steps: [
        "Apri EquiSight",
        "Tocca \"Veterinario\"",
        "Chiama direttamente",
      ],
      tagline: "Niente stress. Niente ricerche. Solo azione.",
    },
    features: [
      "Tutti i numeri di emergenza in un unico posto",
      "Chiama con un tocco dall'app",
      "Manda un WhatsApp con un tocco",
      "Naviga direttamente verso l'indirizzo",
      "Lista contatti personalizzata per ogni cavallo",
      "Veterinario, clinica, maniscalco, dentista, fisioterapista",
      "Indirizzo e indicazioni stradali disponibili immediatamente",
      "Contrassegna i numeri preferiti con una stella",
      "Numeri di emergenza (112, 144) sempre in cima",
    ],
    benefits: [
      "Calma e controllo in una situazione di emergenza",
      "Tutti nella scuderia hanno gli stessi numeri pronti",
      "Niente più biglietti da visita dimenticati",
      "Reagisci secondi più velocemente in caso di urgenza",
    ],
    audience: "Per proprietari di cavalli, addetti alla cura, istruttori e scuderie — chiunque sia responsabile di un cavallo.",
    showcase: {
      eyebrow: "Già configurato per te",
      title: "13 categorie di contatti — pronte da compilare.",
      description: "Dal veterinario e dalla clinica d'urgenza al sellaio, all'istruttore e al gestore del pascolo. EquiSight conosce il tuo mondo e predispone i campi contatto giusti per te. Tocca, compila, fatto.",
      bullets: [
        "Emergenza e salute — veterinario, urgenze, clinica, linea antiveleni",
        "Cura quotidiana — maniscalco, dentista, fisioterapista, istruttore",
        "Scuderia e pascolo — responsabile della scuderia, gestore del pascolo, pensione cavalli",
        "Mangime e materiali — fornitori di fieno, mangime concentrato e paglia",
      ],
      image: {
        url: "/assets/emergency-manage.png",
        alt: "Schermata di gestione dei contatti di emergenza — tutti i contatti suggeriti per categoria",
        embeddedFrame: true,
      },
    },
    checklist: {
      title: "Checklist numeri di emergenza per il cavallo",
      items: [
        "Veterinario",
        "Clinica d'urgenza (24/7)",
        "Ambulanza veterinaria · 144",
        "Maniscalco",
        "Contatto di riserva",
        "Numero di emergenza generale · 112",
      ],
      cta: {
        label: "Apri in EquiSight e compila subito",
        href: "/#waitlist",
      },
    },
    pricing: {
      tiers: [
        {
          name: "Numeri di emergenza",
          price: "Gratis",
          note: "Sempre gratuito · per tutti, in ogni abbonamento",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Assicurati di essere preparato",
      title: "Prima che sia necessario.",
      href: "/#waitlist",
    },
    microcopy: [
      "Nessun obbligo",
      "Configurato in 2 minuti",
      "Sempre modificabile",
    ],
  },
};

export default LANDINGS;
